import { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';

import AjvErrors from 'ajv-errors';
import Ajv from 'ajv';
import reduce from 'lodash/reduce';

import { CardHeader, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';

import { machineryManagementActions } from '../../store/reducers/machinery-management';
import { machineDetailsSchema, machineDetailsUISchema, machineTagsSchema } from './form';
import FormModal from '../../common/formModal';
import MetaTagsTable from '../../common/metaTagsTable';

import Styles from '../../theme/commonCss/Styles';
import { get } from 'lodash';
import { useOutletContext } from 'react-router-dom';
import { palette } from '../../theme/palette';
import OntologySelector from '../../common/OntologySelector';

const AddMachine = ({
  isOpen,
  machineData,
  setMachineData,
  machineTagsData,
  setMachineTagsData,
  isEdit,
  closeModal = () => {},
  machineMasterData,
  pageData,
  ontologyData,
}: any) => {
  const themeData: any = useTheme();
  const dispatch = useDispatch();
  const responsiveSize = useMediaQuery('(max-width:900px)');
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const [ajvErrors, setAjvErrors] = useState<any>({});
  const [isValidName, setIsValidName] = useState<any>({});
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setMachineData({ ...machineData, [name]: value });
    // machineMasterData
    if (name === 'machine_name' && !isEdit) {
      if (machineMasterData.findIndex((item: any) => item.machine_name.toLowerCase() === value.toLowerCase()) > -1) {
        var obj = {
          ['machine_name']: true,
        };
        setIsValidName(obj);
      } else {
        setIsValidName({});
      }
    }
    // validateForm();
  };

  const validateForm = () => {
    let ajvSchema: any = JSON.parse(JSON.stringify({ ...machineDetailsSchema }));

    if (machineTagsData.length) {
      ajvSchema = {
        ...machineDetailsSchema,
        properties: {
          ...machineDetailsSchema.properties,
          machine_tags: {
            type: 'array',
            items: machineTagsData.map((item: any) => machineTagsSchema),
          },
        },
        required: [...machineDetailsSchema.required, 'machine_tags'],
      };
    }

    const validate = ajv.compile(ajvSchema);

    const trimmedMachineData = reduce(
      machineData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );

    const trimmedMachineTagsData = reduce(
      machineTagsData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );

    setMachineData(trimmedMachineData);

    const reqParams = {
      ...trimmedMachineData,
      machine_tags: machineTagsData,
    };

    if (validate({ ...reqParams })) {
      setAjvErrors({});
      return true;
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
      return false;
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    let ajvSchema: any = JSON.parse(JSON.stringify({ ...machineDetailsSchema }));

    if (machineTagsData.length) {
      ajvSchema = {
        ...machineDetailsSchema,
        properties: {
          ...machineDetailsSchema.properties,
          machine_tags: {
            type: 'array',
            items: machineTagsData.map((item: any) => machineTagsSchema),
          },
        },
        required: [...machineDetailsSchema.required, 'machine_tags'],
      };
    }

    const validate = ajv.compile(ajvSchema);

    const trimmedMachineData = reduce(
      machineData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );
    setMachineData(trimmedMachineData);

    const trimmedMachineTag = machineTagsData.map((item: any) => {
      return {
        ...item,
        key: typeof item.key === 'string' ? item.key.trim() : item.key,
        value: typeof item.value === 'string' ? item.value.trim() : item.value,
      };
    });

    setMachineTagsData(trimmedMachineTag);

    const reqParams = {
      ...trimmedMachineData,
      machine_tags: trimmedMachineTag,
    };

    if (validate({ ...reqParams })) {
      if (isEdit) {
        // console.log(reqParams)
        dispatch(machineryManagementActions.updateMachineRequest(reqParams));
      } else {
        if (
          machineMasterData.findIndex(
            (item: any) => item.machine_name.toLowerCase() === machineData.machine_name.toLowerCase()
          ) > -1
        ) {
          var obj = {
            ['machine_name']: true,
          };
          setIsValidName(obj);
        } else {
          // if (isEdit) {
          //   dispatch(machineryManagementActions.updateMachineRequest(reqParams));
          // } else {
          dispatch(machineryManagementActions.addMachineRequest(reqParams));
          // }
        }
      }
      // closeModal();
      setAjvErrors({});
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
    }
  };

  return (
    <FormModal
      title={`${isEdit ? 'EDIT ' : 'ADD NEW '} ${get(pageData, 'entity_name', 'Machine').toUpperCase()}`}
      isOpen={isOpen}
      handleSubmit={handleSubmit}
      handleClose={closeModal}
    >
      <CardHeader title={`${get(pageData, 'entity_name', 'Machine')} Details`} titleTypographyProps={Styles.title} />
      <Divider />
      <Grid
        container
        spacing={1}
        textAlign={'right'}
        sx={{
          ...Styles.gridContainer,
          '&.MuiGrid-root': {
            paddingBottom: '20px !important',
          },
          marginLeft: 0,
          marginTop: responsiveSize ? '0px' : '12px',
        }}
      >
        {machineDetailsUISchema.map(({ label, name, required, type }: any) => {
          if (type === 'input') {
            return (
              <Fragment key={name}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  sx={{
                    ...Styles.gridItem,
                    '&.MuiGrid-item': {
                      paddingTop: '24px !important',
                      pl: '0px !important',
                      justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                    },
                  }}
                >
                  <Typography
                    sx={{ ...Styles.inputLabel, color: themeData.palette.text.primary }}
                    className={required ? 'required-field' : ''}
                  >
                    {label.replace('Machine', get(pageData, 'entity_name', 'Machine'))}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  sx={{
                    '&.MuiGrid-item': {
                      padding: responsiveSize ? '4px 0 0' : '12px 0px',
                      pl: '0px',
                    },
                  }}
                >
                  <TextField
                    sx={{
                      '&.MuiTextField-root': {
                        margin: '0px',
                      },
                    }}
                    margin='normal'
                    fullWidth
                    id={name}
                    onChange={handleChange}
                    // onBlur={validateForm}
                    name={name}
                    autoComplete={name}
                    // autoFocus={name === 'machine_name' ? true : false}
                    variant='outlined'
                    value={machineData[name]}
                    size='small'
                    helperText={
                      name === 'machine_name' ? (
                        isValidName['machine_name'] ? (
                          <p
                            style={{
                              color: palette.error.main,
                              fontSize: '0.75rem',
                              textAlign: 'left',
                              padding: '0',
                              margin: '0',
                              marginLeft: '5px',
                            }}
                          >
                            {get(pageData, 'entity_name', 'Machine').toUpperCase()} NAME already exists!! Please specify
                            alternative "{get(pageData, 'entity_name', 'Machine').toUpperCase()} NAME".{' '}
                          </p>
                        ) : (
                          ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message
                        )
                      ) : (
                        ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message
                      )
                    }
                    error={
                      name === 'machine_name'
                        ? isValidName['machine_name']
                          ? true
                          : ajvErrors.instancePath && ajvErrors.instancePath.includes(name)
                        : ajvErrors.instancePath && ajvErrors.instancePath.includes(name)
                    }
                  />
                  {/* {(isValidName['machine_name'] && name === 'machine_name') && <p style={{ color: '#D81010', fontSize: '0.75rem', textAlign: 'left', padding: '0', margin: '0', marginLeft: '5px' }}>MACHINE NAME already exists!! Please specify alternative "MACHINE NAME". </p>} */}
                </Grid>
              </Fragment>
            );
          }
          if (type === 'ontology') {
            return (
              <Fragment key={name}>
                <OntologySelector
                  ontoManageId={machineData.onto_manage_id}
                  ontologyData={ontologyData}
                  showLayout={false}
                  onOntoFilterChange={(data: any) => {
                    setMachineData({ ...machineData, onto_manage_id: data.onto_manage_id });
                  }}
                  isError={ajvErrors.instancePath && ajvErrors.instancePath.includes(name)}
                />
              </Fragment>
            );
          }
        })}
      </Grid>

      <CardHeader title='Metadata (Supporting information for effective search)' titleTypographyProps={Styles.title} />
      <Divider />
      <MetaTagsTable
        data={machineTagsData}
        setData={setMachineTagsData}
        error={ajvErrors.instancePath && ajvErrors.instancePath.includes('machine_tags')}
      />
    </FormModal>
  );
};

export default AddMachine;
